// MUI-thema: alleen de focus-/selectiekleur van invoervelden paars i.p.v.
// MUI-blauw. Verder het standaardthema (bewust geen palette.primary, dat zou
// ook knoppen, spinners e.d. verkleuren). sx-styling per component wint.
import { createTheme } from "@mui/material/styles";

const FOCUS = "#6c48d8";

const theme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: { [`&.Mui-focused .MuiOutlinedInput-notchedOutline`]: { borderColor: FOCUS } },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: { "&::after": { borderBottomColor: FOCUS } },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        underline: { "&::after": { borderBottomColor: FOCUS } },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: { "&.Mui-focused": { color: FOCUS } },
      },
    },
  },
});

export default theme;
